import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAssetUrl } from '../utils/assetHelper';

// Reusable Feature Item Component
const FeatureItem = ({ title, description, imageSrc, isReversed, t }) => {
  return (
    <div className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center mb-24`}>
      {/* Image Container */}
      <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
        <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden shadow-xl bg-dark-gray">
          <img
            src={imageSrc}
            alt={t(title)}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      </div>
      {/* Text Content */}
      <div className={`w-full lg:w-1/2 ${isReversed ? 'lg:pr-16' : 'lg:pl-16'}`}>
        <h3 className="text-3xl font-bold mb-4 text-primary">
          {t(title)}
        </h3>
        <p className="text-primary text-lg">
          {t(description)}
        </p>
        {/* Individual CTA removed as per request */}
      </div>
    </div>
  );
};

// Main Features Component
const Features = () => {
  const { t } = useTranslation();

  // Feature data array
  const features = [
    {
      title: "featuresSection.feature1.title",
      description: "featuresSection.feature1.description",
      imageSrc: getAssetUrl('images/1_user.webp')
    },
    {
      title: "featuresSection.feature2.title",
      description: "featuresSection.feature2.description",
      imageSrc: getAssetUrl('images/2_user.webp')
    },
    {
      title: "featuresSection.feature3.title",
      description: "featuresSection.feature3.description",
      imageSrc: getAssetUrl('images/3_user.webp')
    }
  ];

  return (
    <section id="features" className="pt-24 pb-12 bg-background"> {/* Reduced bottom padding */}
      <div className="container mx-auto px-4">
        {/* Main Title and Subtitle */}
        <h2 className="text-4xl lg:text-5xl font-bold text-center text-primary mb-4"> {/* Adjusted text size */}
          {t('featuresSection.mainTitle')}
        </h2>
        <p className="text-xl lg:text-2xl text-center text-primary mb-16"> {/* Adjusted text size */}
          {t('featuresSection.subTitle')}
        </p>

        {/* Map over features data */}
        {features.map((feature, index) => (
          <FeatureItem
            key={index}
            {...feature}
            isReversed={index % 2 !== 0} // Alternate layout
            t={t} // Pass translation function
          />
        ))}
      </div>
    </section>
  );
};

export default Features;
